import React from 'react'
import { TextBlock } from '../../../../components/1elements'
import Paper from '@mui/material/Paper';
import { makeStyles } from '@material-ui/core/styles';

const PolyEdit = ({ shape, setShape }) => {
  const classes = useStyles();

  const changeRelay = e => {
    if (!e.target.value && e.target.name !== 'name') {
      e.defaultPrevented = true
      e.isDefaultPrevented = true
      return
    }
    const nameParts = e.target.name.split('.')
    if (nameParts.length === 3) {
      // this is where the lat/lng lives
      const coords = shape.coords
      console.log('coords b4', JSON.stringify(coords))
      coords[nameParts[1]][nameParts[2]] = Number(e.target.value)

      setShape({ id: shape.id, coords }, true)
    } else {
      const needRedraw = e.target.name !== 'name'
      setShape({ id: shape.id, [e.target.name]: e.target.value }, needRedraw)
    }
  }

  return (
    <Paper elevation={0}>
      <TextBlock className={classes.textBlock} heading={shape.name + ':'} key={'name'}>
        <div className={classes.label}>Name:</div>
        <input
          type='text'
          name='name'
          value={shape.name}
          onChange={changeRelay}
          required
          maxLength={150}
          className={classes.input}
        />
      </TextBlock>
      <TextBlock className={classes.textBlock} heading={'Coordinates: '} key={'coords'}>
        {shape.coords.map((onePair, index) => (
          <div key={index}>
            <div className={classes.label} key={`label.${index}.lat`}>Lat:</div>
            <input
              type='number'
              name={`coords.${index}.lat`}
              key={`coords.${index}.lat`}
              value={onePair.lat}
              onChange={changeRelay}
              max={90}
              min={-90}
              required
              step={'any'}
              className={classes.input}
            />
            <div className={classes.label} key={`label.${index}.lng`}>Lng:</div>
            <input
              type='number'
              name={`coords.${index}.lng`}
              key={`coords.${index}.lng`}
              value={onePair.lng}
              onChange={changeRelay}
              max={180}
              min={-180}
              required
              step={'any'}
              className={classes.input}
            />
          </div>
        ))}
      </TextBlock>
    </Paper>
  )
}

const useStyles = makeStyles({
  input: {
    width: '100%',
  },
  label: {
    padding: '5px 0',
  },
  textBlock: {
    padding: '5px 0',
  },
});

export default React.memo(PolyEdit)
